"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCircularReplacer = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getCircularReplacer = () => {
    const cache = new WeakSet();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (cache.has(value)) {
                return;
            }
            cache.add(value);
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return,consistent-return
        return value;
    };
};
exports.getCircularReplacer = getCircularReplacer;
//# sourceMappingURL=json.js.map